import { useMutation } from '@tanstack/react-query';

import { deleteArtistProfile } from './request';

export const useDeleteArtistMutation = () =>
  useMutation({
    mutationKey: ['deleteArtist'],
    mutationFn: deleteArtistProfile
  });
